import React, {Component, useEffect, useState} from 'react';
import {Icons} from '../../../util/icons';
import * as fonts from '../../../util/fonts';
import "./styles.scss";
import ModalTemplate from '../../../components/modal/ModalTemplate';
import {Column, Row} from '../../../components/layout';
import AppButton from '../../../components/app-button';
import colors from '../../../util/colors';
import Icon from './../../../components/icon/Icon';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../util/strings';



interface HealthDataPopupProps {
    show: boolean;
    setShowModal(value: any): void;
    withdraw: any;
    refresh: any;
    labels: typeof strings.pt.permissions;
}

function HealthDataPopup({
    show,
    setShowModal,
    withdraw,
    refresh,
    labels,
}: HealthDataPopupProps) {

    return (
      <div className="errorPopup-modal-content p-0">
        <ModalTemplate
          className="health-data-popup-modal"
          contentClassName="health-data-popup-modal-content"
          show={show}
          onHide={() => {
            setShowModal(false);
            refresh();
          }}
          cross={true}
          hideFooter={true}
          size="sm">
          <Column className="errorPopup-column">
            <Row className="health-data-title-row">
              <p
                style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                className="p-myProfilePopup">
                {labels?.permissions_advplus_title}
              </p>
            </Row>
            <Row className="health-data-popup-icon-row">
              <div className="health-data-popup-icon-container">
                <Icon
                  className="errorPopup-icon"
                  name={Icons.ALERT_PROBLEM}
                  width="18"
                  height="25"
                  color={colors.alertRed}
                />
              </div>
            </Row>
            <Row className="errorPopup-title-row">
              <p
                style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
                className="p-errorPopup">
                {labels?.permissions_continueQuestion}
              </p>
            </Row>
            <Row className="errorPopup-title-row">
              <p
                style={{...fonts.MM, color: colors.black, marginTop: '-20px'}}
                className="p-health-data-popup">
                {labels?.permissions_advPlusAlertText2}
              </p>
            </Row>
            <Row className="errorPopup-button">
              <AppButton
                className="health-data-button-yes"
                onClick={() => {
                  setShowModal(false);
                  withdraw();
                }}
                variant="secondary">
                {labels?.permissions_yes}
              </AppButton>
              <AppButton
                className="health-data-button-no"
                onClick={() => {
                  setShowModal(false);
                  refresh();
                }}
                variant="secondary">
                {labels?.permissions_no}
              </AppButton>
            </Row>
          </Column>
        </ModalTemplate>
      </div>
    );
    }

    const mapStateToProps = ({
        strings,
      }: any) => ({
        labels: strings.value.pt.permissions,
      });

      const mapDispatchToProps = (dispatch: any) => ({
      });      
  
    export default compose(
        connect(mapStateToProps, mapDispatchToProps)(HealthDataPopup)
      );

